import { VariationsSystemHelperText } from '../view/VariationsSystemHelperTextCopy';

interface GetSystemHelperTextForVariations {
  hasVariations?: boolean;
  hasVariationsConditionalLogic?: boolean;
  selectedVariationId?: string;
  isLibraryPage?: boolean;
  isBlocks?: boolean;
  isClauses?: boolean;
}

export const getSystemHelperTextForVariations = ({
  hasVariations,
  hasVariationsConditionalLogic,
  selectedVariationId,
  isLibraryPage = false,
  isBlocks = false,
  isClauses = false,
}: GetSystemHelperTextForVariations): VariationsSystemHelperText => {
  switch (true) {
    case !hasVariations:
      return VariationsSystemHelperText.NO_VARIATIONS;

    case hasVariationsConditionalLogic && isBlocks:
      return VariationsSystemHelperText.VARIATIONS_LOGIC_BLOCKS;

    case hasVariationsConditionalLogic && isClauses:
      return VariationsSystemHelperText.VARIATIONS_LOGIC_CLAUSES;

    case !selectedVariationId && !isLibraryPage:
      return VariationsSystemHelperText.SELECT_VARIATIONS;

    case hasVariations && isClauses:
      return VariationsSystemHelperText.VARIATIONS_CLAUSES;

    default:
      return VariationsSystemHelperText.VARIATIONS_BLOCKS;
  }
};
